import { render } from "./OsgbBranch.vue?vue&type=template&id=52db61e4"
import script from "./OsgbBranch.vue?vue&type=script&lang=js"
export * from "./OsgbBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__